<dashboardnav>

<!-- 
<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="audittrayForm">
        <div class="">
          <h3 class="form_name">Audit Tray</h3>
    
    
            <div class="input">
              <label for="">Actioned By:</label>
              <select class="default_input reference-form" [(ngModel)]="searchText" formControlName="StaffId" #staff style="width: 100%">
                <option value=""> Select Staff </option>
                    <option *ngFor="let staff of actionedstaff" [value]="staff.id">
                     {{staff.StaffName}}
                    </option>
            </select> 
            </div>
    
            <div class="input">
              <label for="">From Date</label>
              <input type="date" formControlName="StartDate" >
            </div>

            <div class="input">
              <label for="">To Date</label>
              <input type="date" formControlName="EndDate" >
               <input type="date" formControlName="StartDate" >
            </div>
    
          <div class="btn_holder">
            <button class="default_primary-button" (click)="searchRecords()">Search</button>
           
          </div>
    
        </div>
      </form>

      <div class="display_table">        
  
        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Actioned By</span>
          <span class="item">Date</span>
          <span class="item">Time</span>
          <span class="item">Module</span>
          <span class="item">Activity</span>
          <span class="item">Description</span>
          <span class="item">Amount</span>
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body" *ngFor="let audittray of filteredAudittrays; index as i" >
       
          <span class="content">{{i + 1}}</span>
          <span class="content">{{audittray.ActionedBy}}</span>
          <span class="content">{{audittray.ActionDate | date}}</span>
          <span class="content">{{audittray.ActionTime}}</span>
          <span class="content">{{audittray.ActionModule}}</span>
          <span class="content">{{audittray.ActionActivity}}</span>
          <span class="content">{{audittray.ActionDescription}}</span>
          <span class="content">{{audittray.ActionAmount}}</span>
        </div>
        </div>
        
      </div>
    </div>
  </main> -->
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>





  <main class="the_audit">
    <div class="containing">

      <form [formGroup]="audittrayForm">
        <div class="">
      <div class="the_top">
        <!-- top left part  -->
        <h2 class="title">Audit Tray</h2>

        <!-- top right part -->

        <div class="filter_search">
          <div class="holding">
            <div class="input">
              <label for="">Select action by</label>
              <select class="default_input" [(ngModel)]="searchText" formControlName="StaffId" #staff style="width: 100%">
                <option value=""> Select Staff </option>
                    <option *ngFor="let staff of actionedstaff" [value]="staff.id">
                     {{staff.StaffName}}
                    </option>
            </select> 
             
            </div>

            <div class="all"><input type="checkbox" name="" id="" /> <label for="">View all</label></div>
          </div>

          <div class="input">
            <label for="">From</label>
            <input type="date" class="default_input" formControlName="StartDate"/>
           
          </div>

          <div class="input">
            <label for="">To</label>
            <input type="date" class="default_input" formControlName="EndDate"/>
          </div>
          <button class="default_secondary-btn Add_new" (click)="searchRecords()">View</button>
        </div>
      </div>

      <div class="fetched_details">
        <div class="heading">
          <!-- <span class="head">S/N</span>
          <span class="head">Activity</span>
          <span class="head">Action By</span>
          <span class="head">Action Date</span>
          <span class="head">Action Time</span>
          <span class="head">Action Module</span>
          <span class="head">Action Activity</span>
          <span class="head">Action Description</span>
          <span class="head">Action Amount</span> -->

          <span class="head">S/N</span>
          <span class="head">Actioned By</span>
          <span class="head">Date</span>
          <span class="head">Time</span>
          <span class="head">Module</span>
          <span class="head">Activity</span>
          <span class="head">Description</span>
          <span class="head">Amount</span>
        </div>

        <div class="row" *ngFor="let audittray of filteredAudittrays; index as i" >
          <!-- <span class="item">1</span>
          <span class="item">Modified</span>
          <span class="item">Mbato Robinson</span>
          <span class="item">16/10/2020</span>
          <span class="item">2020-10-16T15:47:25.46</span>
          <span class="item">Action Module</span>
          <span class="item">Modified</span>
          <span class="item">Encroachment Modified</span>
          <span class="item">2</span> -->

          <span class="item">{{i + 1}}</span>
          <span class="item">{{audittray.ActionedBy}}</span>
          <span class="item">{{audittray.ActionDate | date}}</span>
          <span class="item">{{audittray.ActionTime}}</span>
          <span class="item">{{audittray.ActionModule}}</span>
          <span class="item">{{audittray.ActionActivity}}</span>
          <span class="item">{{audittray.ActionDescription}}</span>
          <span class="item">{{audittray.ActionAmount}}</span>
        </div>

   
      </div>

      <!-- <div class="submit">
        <button class="default_primary-button">Done</button>
      </div> -->
    </div>
      </form>
    </div>
  </main>
</dashboardnav>